import React from 'react';
import Messaging from '../../../../../../context/Messaging';

const ThankYouPreview: React.FC = () => {
  return (
    <div
      className='col-xs-12 py-3'
      id='thank-you-preview-content'
      role='region'
      aria-label='Preview mode content for Thank You'
    >
      {<Messaging dynamic preview section='wizard.thankYou.body' />}
    </div>
  );
};

export default ThankYouPreview;
